/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Block} from 'baseui/block'
import React from 'react'
import {Avatar} from 'baseui/avatar'

const UserAvatar = () => {
  return (
    <Block
      overrides={{
        Block: {
          style: ({$theme}) => ({
            color: $theme.colors.mono800,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: $theme.sizing.scale800,
            marginTop: $theme.sizing.scale800,
            width: '100%',
          }),
        },
      }}
    >
      <Avatar
        name={'icon'}
        size={'scale3200'}
        src={
          'https://firebasestorage.googleapis.com/v0/b/sotsc-platform-dev.appspot.com/o/sotsc-public%2Fimages%2Fui%2Fhud-player.svg?alt=media&token=26abc53e-d058-4663-a66e-308e588cf00b'
        }
        overrides={{
          Avatar: {
            style: ({$theme}) => ({
              outline: `${$theme.colors.primary} solid`,
            }),
          },
        }}
      />
    </Block>
  )
}

export default UserAvatar
